export function nextOffset(
  lastPage: { total: number },
  allPages: { items: unknown[] }[],
): number | undefined {
  const loaded = allPages.reduce((sum, page) => sum + page.items.length, 0)
  return loaded < lastPage.total ? loaded : undefined
}
